/**
 * Angular imports.
 */
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Module imports.
 */
import { WebCalendarActionsModule } from './../../web-calendar/web-calendar-actions/web-calendar-actions.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PipesModule } from './../../pipes/pipes.module';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

/**
 * Component imports.
 */
import { EventListComponent } from './event-list/event-list.component';
import { CalenderEventComponent } from './calender-event.component';


@NgModule({
  declarations: [
    CalenderEventComponent,
    EventListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    InfiniteScrollModule,
    WebCalendarActionsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
  ],
  exports: [
    CalenderEventComponent,
    EventListComponent
  ]
})
export class CalenderEventModule { }
